import { Mixins, Component, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import LogTemplate from '@/views/Log/components/template/template.vue'
import Log from '@/views/Log/models/log'
import ContractorInfo from '@/views/Project/Observation/components/contractorInfo.vue'

@Component({
    inheritAttrs: false,
    name: 'log-authorization',
    components: { LogTemplate, ContractorInfo },
})
export default class LogAuthorization extends Mixins<MixinInterface>() {
    @Prop({ required: true }) log!: Log

    get customString() {
        switch (this.log.logEventName) {
            case 'rolePermissionsUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['kind'] == 'normal' ? 'kind(normal)' : 'kind(general)'
                }`
            case 'projectUserCreated':
                return `${this.log.logEventName}_${
                    this.log.actingUser ? 'notNull(actingUser)' : 'isNull(actingUser)'
                }`
            case 'pendingProjectUserDisplayContractorUpdated':
            case 'projectUserDisplayContractorUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload.new ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'projectUserRolesUpdated':
                return `${this.log.logEventName}_${
                    this.log.actingUser ? 'notNull(actingUser)' : 'isNull(actingUser)'
                }`
            case 'pendingProjectUserJobTitleUpdated':
            case 'projectUserJobTitleUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload.new ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'pendingProjectUserJobDescriptionUpdated':
            case 'projectUserJobDescriptionUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload.new ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'roleIsSuggestedContractorRoleUpdated':
                return `${this.log.logEventName}.${
                    this.log.payload.new ? 'isTrue(new)' : 'isFalse(new)'
                }`
            case 'projectUserContractorRoleRemoved':
            case 'projectUserContractorRoleAdded':
            case 'pendingProjectUserContractorRoleRemoved':
            case 'pendingProjectUserContractorRoleAdded':
                return `${this.log.logEventName}.${
                    ['normal', 'system.contractorAdmin'].includes(this.log.payload.role.kind)
                        ? 'isEqual'
                        : 'notEqual'
                }(role.kind,normal).${
                    this.log.payload.includeSubcontractors
                        ? 'isTrue(includeSubcontractors)'
                        : 'isFalse(includeSubcontractors)'
                }`
            case 'projectUserContractorRoleAssignmentIncludeSubcontractorsUpdated':
            case 'pendingProjectUserContractorRoleAssignmentIncludeSubcontractorsUpdated':
                return `${this.log.logEventName}.${
                    this.log.payload.role.kind === 'normal' ? 'isEqual' : 'notEqual'
                }(role.kind,normal).${
                    this.log.payload.includeSubcontractors ? 'isTrue(new)' : 'isFalse(new)'
                }`
            default:
                return this.log.logEventName
        }
    }

    newAttachment: any = null
    oldAttachment: any = null
    attachment: any = null
    editorJS: any = null

    async created() {
        switch (this.log.logEventName) {
            case 'observationCreated':
                if (this.log.payload.describtion) {
                    this.editorJS = {
                        newVal: this.log.payload.describtion,
                        oldVal: null,
                    }
                }
                break

            case 'observationAttachmentCreated':
                this.attachment = this.log.payload
                    ? {
                          fileId: this.log.payload.fileId,
                          filename: this.log.payload.filename,
                      }
                    : null
                break
        }
    }
}
